import { useEffect, useMemo, useCallback, useState } from "react";
import { fixtureService } from "@/frontend/services";
import type { FixtureResponseDTO } from "@/shared/dto";
import type { StageConfig } from "@/core/value-objects/StageConfig";
import type { SeasonInfo, TournamentStageInfo } from "../types";
import { KnockoutBracket } from "@/frontend/components/domain/KnockoutBracket";

interface KnockoutTabProps {
  stages: StageConfig[];
  currentSeason: SeasonInfo;
  tournamentStages: TournamentStageInfo[];
}

export function KnockoutTab({
  stages,
  currentSeason,
}: KnockoutTabProps) {
  const [knockoutFixtures, setKnockoutFixtures] = useState<FixtureResponseDTO[]>([]);

  const allKnockoutStages = useMemo(
    () => stages.filter((s) => s.type === "KNOCKOUT"),
    [stages]
  );

  const mainKnockoutStages = useMemo(
    () => allKnockoutStages.filter((s) => !s.isConsolation),
    [allKnockoutStages]
  );

  const consolationStages = useMemo(
    () => allKnockoutStages.filter((s) => s.isConsolation),
    [allKnockoutStages]
  );

  const fetchKnockoutFixtures = useCallback(async () => {
    if (!currentSeason?.id) return;
    
        try {
      const resp = await fixtureService.getKnockoutTree(currentSeason.id);
      if (resp.success && resp.data) {
        const flatFixtures: (FixtureResponseDTO & { stageOrder?: number })[] = [];
        for (const group of resp.data) {
          for (const f of group.fixtures) {
            flatFixtures.push({ ...f, stageOrder: group.stageOrder ?? undefined });
          }
        }
        setKnockoutFixtures(flatFixtures as FixtureResponseDTO[]);
      }
    } catch (e) {
      console.error("Error cargando fixtures knockout", e);
    }
  }, [currentSeason?.id]);

  useEffect(() => {
    fetchKnockoutFixtures();
  }, [fetchKnockoutFixtures]);


  if (mainKnockoutStages.length === 0) {
    return null;
  }

  const consolationStage = consolationStages[0];

  return (
    <div className="py-4">
      <KnockoutBracket
        stages={stages}
        mode="auto"
        consolationStage={consolationStage}
        fixtures={knockoutFixtures}
      />
    </div>
  );
}
